"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(a) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _antd = require("antd"),
    _Button = _interopRequireDefault(require("../../Button")),
    S = _interopRequireWildcard(require("./styles"));

function _getRequireWildcardCache() {
  if ("function" != typeof WeakMap) return null;
  var a = new WeakMap();
  return _getRequireWildcardCache = function _getRequireWildcardCache() {
    return a;
  }, a;
}

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  if (null === a || "object" !== _typeof(a) && "function" != typeof a) return {
    "default": a
  };

  var b = _getRequireWildcardCache();

  if (b && b.has(a)) return b.get(a);
  var c = {},
      d = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var e in a) {
    if (Object.prototype.hasOwnProperty.call(a, e)) {
      var f = d ? Object.getOwnPropertyDescriptor(a, e) : null;
      f && (f.get || f.set) ? Object.defineProperty(c, e, f) : c[e] = a[e];
    }
  }

  return c["default"] = a, b && b.set(a, c), c;
}

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var SubMenu = _antd.Menu.SubMenu,
    Title = function Title(a) {
  var b = a.title,
      c = a.count;
  return _react["default"].createElement("span", null, b, _react["default"].createElement(S.BadgeWrapper, null, _react["default"].createElement(_antd.Badge, {
    count: c,
    style: {
      backgroundColor: "white",
      color: "#222",
      border: "1px solid #e5e5e5"
    }
  })));
},
    _default = function _default(a) {
  var b = a.relationships,
      c = a.isLoading,
      d = _react["default"].createElement(_antd.Menu, null);

  if (b) {
    var e = b.exceptions,
        f = b.attributes,
        g = b.dynamicUsages,
        h = b.staticUsages,
        i = b.enumerations,
        j = b.billingItem;
    d = _react["default"].createElement("div", null, _react["default"].createElement(_antd.Menu, null, e && 0 < e.length ? _react["default"].createElement(SubMenu, {
      title: _react["default"].createElement(Title, {
        count: e.length,
        title: "exceptions"
      })
    }, e.map(function (a) {
      return _react["default"].createElement(_antd.Menu.Item, null, a.code);
    })) : null, f && 0 < f.length ? _react["default"].createElement(SubMenu, {
      title: _react["default"].createElement(Title, {
        count: f.length,
        title: "attributes"
      })
    }, f.map(function (a) {
      return _react["default"].createElement(_antd.Menu.Item, null, a.attributeId);
    })) : null, g && 0 < g.length ? _react["default"].createElement(SubMenu, {
      title: _react["default"].createElement(Title, {
        count: g.length,
        title: "dynamicUsages"
      })
    }, g.map(function (a) {
      return _react["default"].createElement(_antd.Menu.Item, null, "Flow: ".concat(a.flow.name, " ver: ").concat(a.flow.version, " "), null == a.processTitle ? null : "Process: ".concat(a.processTitle, " "), null == a.stepTitle ? null : "step: ".concat(a.stepTitle));
    })) : null, h && 0 < h.length ? _react["default"].createElement(SubMenu, {
      title: _react["default"].createElement(Title, {
        count: h.length,
        title: "staticUsages"
      })
    }, h.map(function (a) {
      return _react["default"].createElement(_antd.Menu.Item, null, a.location);
    })) : null, i && 0 < i.length ? _react["default"].createElement(SubMenu, {
      title: _react["default"].createElement(Title, {
        count: i.length,
        title: "enumerations"
      })
    }, i.map(function (a) {
      return _react["default"].createElement(_antd.Menu.Item, null, a.id);
    })) : null, j ? _react["default"].createElement(SubMenu, {
      title: _react["default"].createElement(Title, {
        title: "billingItem"
      })
    }, i.map(function () {
      return _react["default"].createElement(_antd.Menu.Item, null, "Billing item: Yes");
    })) : null));
  }

  return _react["default"].createElement("div", null, _react["default"].createElement(_antd.Dropdown, {
    overlay: d,
    trigger: ["hover"]
  }, c ? _react["default"].createElement(_Button["default"], {
    size: "small",
    type: "link",
    shape: "circle",
    loading: !0
  }) : _react["default"].createElement("div", null, null == b ? null : _react["default"].createElement(_Button["default"], {
    size: "small",
    type: "link",
    icon: "more"
  }))));
};

exports["default"] = _default;